import React from 'react';
import { Modal, useBreakpoint } from '@landr/maestro';
import AdvancedFiltersModalContent from 'components/Filters/components/SearchTools/AdvancedFiltersModalContent';
import { ModalProps } from 'modals/Modal.types';

export const AdvancedFiltersModal: React.FC<ModalProps> = ({
    handleClose,
    isOpen,
}) => {
    const isMobile = useBreakpoint('md');

    if (isMobile) {
        return null;
    }

    return (
        <Modal
            width="1200px"
            height="90%"
            isOpen={isOpen}
            onClose={handleClose}
            backgroundColor="surface.high"
            color="text.high"
            overflow={'hidden'}
        >
            <AdvancedFiltersModalContent handleClose={handleClose} />
        </Modal>
    );
};

export default AdvancedFiltersModal;
